export { default as Img200 } from './processed/200/All-The-Money-In-The-World.jpg';
export { default as Img400 } from './processed/400/All-The-Money-In-The-World.jpg';
export { default as Imgthumb } from './processed/thumb/All-The-Money-In-The-World.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/All-The-Money-In-The-World.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/All-The-Money-In-The-World.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      179,
      24,
      26
    ],
    "_population": 2539,
    "_hsl": [
      0.9978494623655915,
      0.7635467980295566,
      0.3980392156862745
    ]
  },
  "LightVibrant": {
    "_rgb": [
      214,
      229,
      239
    ],
    "_population": 330,
    "_hsl": [
      0.5666666666666667,
      0.43859649122807015,
      0.888235294117647
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      26,
      86,
      92
    ],
    "_population": 25,
    "_hsl": [
      0.5151515151515151,
      0.559322033898305,
      0.23137254901960785
    ]
  },
  "Muted": {
    "_rgb": [
      119,
      138,
      143
    ],
    "_population": 2501,
    "_hsl": [
      0.5347222222222223,
      0.0967741935483871,
      0.5137254901960784
    ]
  },
  "LightMuted": {
    "_rgb": [
      172,
      191,
      199
    ],
    "_population": 388,
    "_hsl": [
      0.5493827160493827,
      0.19424460431654667,
      0.7274509803921569
    ]
  },
  "DarkMuted": {
    "_rgb": [
      46,
      78,
      82
    ],
    "_population": 1076,
    "_hsl": [
      0.5185185185185185,
      0.28125000000000006,
      0.25098039215686274
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/All-The-Money-In-The-World.js